import { Button, Form, FormControl, Modal } from "react-bootstrap";
import { LicenceTypeCreateRequest } from "../../../../types/Licences/LicenceTypeCreateRequest";
import { LicenceTypeSummary } from "../../../../types/Licences/LicenceTypeSummary";
import { Formik } from "formik";
import { CreateSchema } from "./CreateSchema";
import { StyledModalTitle } from "../../../../@ui/StyledModalTitle";
import LayerCheckboxes from "../Forms/LayerCheckboxes";
import { ErrorText } from "../../../../@ui/ErrorText";
import ThemedModal from "../../../../@ui/Modal/ThemedModal";

interface LicenceEditModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (values: LicenceTypeCreateRequest) => void;
  licenceTypeSummary: LicenceTypeSummary;
}

const initialValues = { name: "" } as LicenceTypeCreateRequest;

const LicenceTypeCreateModal = ({
  show,
  onClose,
  onSubmit,
  licenceTypeSummary,
}: LicenceEditModalProps) => {
  return (
    <ThemedModal centered show={show} onHide={onClose}>
      <Formik
        validationSchema={CreateSchema}
        onSubmit={onSubmit}
        initialValues={initialValues}
      >
        {({
          values,
          handleSubmit,
          handleChange,
          touched,
          errors,
          handleBlur,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Header className="bg-secondary text-white" closeButton>
              <StyledModalTitle>Create Licence Access</StyledModalTitle>
            </Modal.Header>
            <Modal.Body>
              <Form.Group>
                <Form.Label>Name</Form.Label>
                <FormControl
                  type="text"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.name && touched.name && (
                  <ErrorText className="text-danger px-1">
                    {errors.name}
                  </ErrorText>
                )}
              </Form.Group>
              <LayerCheckboxes layers={licenceTypeSummary.layers} />
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" variant="primary">
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </ThemedModal>
  );
};

export default LicenceTypeCreateModal;
